/**
 * Scheme-independent scales for the web (DS-01): control sizing, spacing steps, z-index, motion and
 * layout. Numbers are px. Colours live in `semantic.ts`.
 */
import { radius } from './foundation.js';
/**
 * Every form control and button shares the height of its size, so controls align in a row.
 * `md` is the default size.
 */
export const controlSizes = {
    sm: { height: 32, paddingX: 12, fontSize: 14 },
    md: { height: 40, paddingX: 14, fontSize: 14 },
    lg: { height: 48, paddingX: 16, fontSize: 16 },
};
export const CONTROL_SIZES = ['sm', 'md', 'lg'];
export const DEFAULT_CONTROL_SIZE = 'md';
/** One radius for every control (buttons, inputs, selects, pickers). */
export const controlRadius = radius.md;
/** Spacing steps on a 4px base: step n is n × 4 px (MUI `theme.spacing(n)` gives the same). */
export const SPACING_BASE = 4;
export const SPACING_STEPS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
/** Stacking order; aligned with MUI's defaults so MUI and custom layers interleave correctly. */
export const zIndex = {
    sticky: 1100,
    drawer: 1200,
    modal: 1300,
    dropdown: 1300,
    toast: 1400,
    tooltip: 1500,
};
/** Durations in ms; the CSS output sets them to 0 under `prefers-reduced-motion: reduce`. */
export const motion = {
    fast: 120,
    normal: 200,
    slow: 300,
};
export const motionEasing = 'cubic-bezier(0.2, 0, 0, 1)';
export const layout = {
    sidebarWidth: 240,
    sidebarCollapsedWidth: 72,
    topbarHeight: 56,
    contentMax: { md: 960, lg: 1200, xl: 1440 },
    /** Fixed-width panels: popovers (xs, sm), error and confirmation cards (md), steppers (lg). */
    panel: { xs: 320, sm: 360, md: 480, lg: 560 },
    /** Page side padding below and from the `md` breakpoint. */
    pagePadding: { base: 16, md: 24 },
    /** MUI's `md` breakpoint: the sidebar becomes a drawer below it. */
    mdBreakpoint: 900,
};
//# sourceMappingURL=scales.js.map